import { Box, Stack } from '@mui/material';
import Image from 'next/image';

import pinkBackgroundSpaceship from '../../../public/statics/images/illustrations/onboarding/pink_background_spaceship.png';

export const WelcomePageWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Box width='100%' height='100%' padding='min(100px,4vw)'>
      <Stack
        width='100%'
        height='100%'
        direction='row'
        justifyContent='space-between'
      >
        <Box className='flex items-center'>
          <Image
            alt='bring-your-own-cloud'
            height={760}
            width={760}
            src={pinkBackgroundSpaceship}
            style={{ width: '40vw', height: '40vw' }}
          />
        </Box>
        <Stack
          sx={{
            overflowY: 'auto',
          }}
          minWidth='50%'
          padding='min(100px,4vw)'
          justifyContent='center'
          className='bg-[white] rounded-[16px]'
        >
          {children}
        </Stack>
      </Stack>
    </Box>
  );
};
